/**
 * Ícone do nível TARP — GUPM-134.
 * NORMAL/ATENÇÃO/EMERGÊNCIA usam o emoji do `LEVEL_UI` (cor própria).
 * ALERTA usa o SVG Material Symbols "brightness_alert" (FILL1), recolorido na
 * cor laranja do nível — emoji não tem um "alerta laranja" e não é recolorível.
 *
 * Centraliza a renderização pra tratar o caso misto (emoji × SVG) num lugar só.
 */
import { LEVEL_UI, type TarpLevel } from './tokens';

const ALERTA_PATH =
  'M508.5-291.5Q520-303 520-320t-11.5-28.5Q497-360 480-360t-28.5 11.5Q440-337 440-320t11.5 28.5Q463-280 480-280t28.5-11.5ZM440-440h80v-240h-80v240Zm40 412L346-160H160v-186L28-480l132-134v-186h186l134-132 134 132h186v186l132 134-132 134v186H614L480-28Z';

export interface LevelIconProps {
  level: TarpLevel;
  /** px — só afeta o SVG (Alerta); o emoji herda o font-size do contexto. */
  size?: number;
  className?: string;
}

export function LevelIcon({ level, size = 16, className = '' }: LevelIconProps) {
  if (level === 'ALERTA') {
    return (
      <svg
        viewBox="0 -960 960 960"
        width={size}
        height={size}
        fill={LEVEL_UI.ALERTA.color}
        aria-hidden
        className={className}
        style={{ display: 'inline-block', verticalAlign: '-0.15em', flexShrink: 0 }}
      >
        <path d={ALERTA_PATH} />
      </svg>
    );
  }
  return <span aria-hidden className={className}>{LEVEL_UI[level].icon}</span>;
}
